import { usePageTitle } from "../hooks/usePageTitle";
import CrispCharterDemo from "../components/CrispCharterDemo";

export default function Charter() {
  usePageTitle("Idea to Charter");
  return (
    <div style={{ paddingTop: "3rem" }}>
      <CrispCharterDemo />
    </div>
  );
}
